@if (propertyFormService.loading$ | async) {
    <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button routerLink="/properties" component="Properties"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <h2>Property Entry</h2>
        </div>
        <div class="row mt-2 mb-5">
            <mat-accordion>
                <property-form-basic-information [propertyFormService]="propertyFormService" *ngIf="organizations" [organizations]="organizations" (selectedOrgIdEvent)="getSelectedOrgPolicies($event)"></property-form-basic-information>
                <property-form-address [propertyFormService]="propertyFormService"></property-form-address>
                <property-form-photos [propertyFormService]="propertyFormService"></property-form-photos>
                <property-form-homeowner [propertyFormService]="propertyFormService"></property-form-homeowner>
            </mat-accordion>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button routerLink="/properties">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-property-button"
                [disabled]="!propertyFormService.isFormValid()" (click)="submitProperty()">
                <mat-icon>check</mat-icon>
                Submit Property
            </button>
        </div>
        @if(!propertyFormService.isFormValid()) {
            <mat-action-row class="mt-4 d-flex justify-content-end">
                <div class="d-flex justify-content-end align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Property Name, Type and Address required before property can be created.
                </div>
            </mat-action-row>
        }
    </div>
}